import Store from './containers/Store';

import reducer from './services/reducer';
import { StorePageState, storeSelectors } from './services/selectors';
import epics from './services/epics';

export { reducer, StorePageState, storeSelectors, epics };

export default Store;



// WEBPACK FOOTER //
// ./src/scenes/Store/index.ts